import React from "react";
import { ModalDialog } from "../../../../components";
import PAGES from "../../../../../../constants/pages";

const EmptiedOrderModal: React.FC = () => {
    const continueClicked = (e: Event): void => {
        e.preventDefault();
        window.location.assign(PAGES.LISTING_PAGES.MOBILE.URL);
    };

    return (
        <ModalDialog
            size="medium"
            submitText="Til nettbutikk"
            closeText="Lukk"
            heading="Din reservasjon er utgått"
            name="none-order-modal"
            onSubmit={continueClicked}
        >
            Din reservasjon av produkter er utgått og handlekurven har blitt tømt.
        </ModalDialog>
    );
};

export default EmptiedOrderModal;
